import {
  FETCH_POSITION_FAIL,
  FETCH_POSITION_REQUEST,
  FETCH_POSITION_SUCCESS,
} from "../../ActionType/BranchType/PositionType";

export const getPositionReducer = (
  state = { loading: true, positions: [], error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_POSITION_REQUEST:
      return {
        loading: true,
        positions: action.payload,
      };
    case FETCH_POSITION_SUCCESS:
      return {
        loading: false,
        positions: action.payload,
        error: "",
      };
    case FETCH_POSITION_FAIL:
      return {
        loading: false,
        positions: action.payload,
        error: "",
      };
    default:
      return state;
  }
};
